<template>
  <div :class="$style['pt-doctor-form']">
    <pt-page-title :title="isEdit?'编辑医生':'新建医生'"></pt-page-title>
    <pt-sub-title title="医生信息"></pt-sub-title>
    <table :class="$style['role-customer-basic-message']">
      <pt-form-list-item label="姓名：" required>
        <wt-input v-model="formValue.name" v-validate="'required'" data-vv-as="姓名" placeholder="请输入姓名"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="科室：" required>
        <wt-input v-model="formValue.department" v-validate="'required'" data-vv-as="科室" placeholder="请输入科室">
        </wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="职位：">
        <!-- <wt-input v-model="formValue.position" placeholder="请输入职位"> -->
          <wt-selector :options="doctorLevels" v-model="formValue.positionCode" placeholder="请选择职位"></wt-selector>
        <!-- </wt-input> -->
      </pt-form-list-item>
      <template>
        <pt-form-list-item label="执业医院：" :required="true">
          <el-button type="primary" plain @click="selectHospital">选择医院</el-button>
          <wt-input v-model="selectHospitalList_info.length" v-validate="'required'" style="display:none" data-vv-as="选择医院"></wt-input>
          <div :class="$style['specification-table-div']" class="page-background" v-if="selectHospitalList_info&&selectHospitalList_info.length">
            <table :class="$style['specification-table']">
              <th>
              <td>医院名称</td>
              <td>分/子公司</td>
              <td>地区</td>
              <td>操作</td>
              </th>
              <tr v-for="(item,index) in selectHospitalList_info" :key="index">
                <td>{{item.name}}</td>
                <td>{{item.branchName}}</td>
                <td>{{item.address}}</td>
                <td @click="deleteRow(index)" style="color:#EDBE81">移除</td>
              </tr>
            </table>
          </div>
        </pt-form-list-item>
      </template>
      <pt-form-list-item label="身份证号：">
        <wt-input v-model="formValue.idCard" placeholder="请输入身份证号"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="手机号：" required>
        <wt-input v-model="formValue.mobile" placeholder="请输入手机号" v-validate="'required|phone'" data-vv-as="手机号"
          type="number"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="所属分/子公司" required>
        <wt-selector data-vv-as="所属分/子公司" v-validate="'required'" filterable :options="company" v-model="formValue.branchCompanyId" :class="$style['org-select']"></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="所属省市：" required>
        <pt-address-select v-model="formValue.addressDetails" required clearable @change="change"  data-vv-as="所属省市" name="name"
              v-validate="'required'" ref="address" :validateText="addressValidateText" :showElement="addressShowElement"></pt-address-select>
      </pt-form-list-item>
    </table>
    <obs-question-message ref="question" :hospitalList="hospitalList" :allMembers="allMembers" v-model="formValue.question" :data="questionFrom" :isEdit="isEdit"></obs-question-message>
    <!-- 医院选择dialog -->
    <hospital-dialog :dialogVisible="is_hospital" :dialogTitle="hospital_title" @close="closeHospitalDialog"
      @selectHospitalList="selectHospitalList" :selectLabels="selectHospitalList_info"></hospital-dialog>
  </div>
</template>

<script>
import hospitalDialog from 'cps/hospital-and-doctor-manage/pt-doctor-manage/hospital-dialog'
import ptAddressSelect from 'cps/base/pt-address-select/withData'
import obsQuestionMessage from './obs-question-message'
import formMixins from 'mixins/form'
import { doctorLevels } from 'json/doctor-hospital'
// 组件class前缀
const prefixCls = 'pt-doctor-form'

export default {
  name: 'pt-doctor-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    address () {
      return this.$refs.address
    },
    question () {
      return this.$refs.question
    },
    questionFrom () {
      let { joinObstetricsQA, headImage, excellent, introduction, qaExtendInfo, idPhoto, qaHospitalIds } = this.doctorDetail
      return { joinObstetricsQA, headImage, excellent, introduction, qaExtendInfo, idPhoto, qaHospitalIds }
    }
  },
  components: {
    hospitalDialog,
    ptAddressSelect,
    obsQuestionMessage
  },
  props: {
    doctorDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    company: {
      type: [Array, String]
    },
    allMembers: {
      type: Array,
      default: function () {
        return []
      }
    },
    hospitalList: Array
  },
  data () {
    return {
      formValue: {
        hospitalIds: [],
        addressDetails: {}
      },
      is_hospital: false,
      hospital_title: '选择医院',
      selectHospitalList_info: [],
      addressShowElement: {
        province: true,
        city: true
      },
      addressValidateText: {
        province: '医生所属省',
        city: '医生所属市'
      },
      requiredObj: {
        province: true,
        city: true
      },
      doctorLevels: doctorLevels
    }
  },
  watch: {
    'formValue.addressDetails' (val) {
      console.log('address', val)
    },
    doctorDetail: {
      handler: function (val) {
        this.formValue = val
        this.selectHospitalList_info = val.hospital
        let newArr = []
        this.selectHospitalList_info.forEach(item => {
          newArr.push(item.id)
          this.formValue.hospitalIds = newArr
        })
      }
    },
    selectHospitalList_info: {
      handler: function (val) {
        let newArr = []
        val.forEach(item => {
          newArr.push(item.id)
          this.formValue.hospitalIds = newArr
        })
      }
    }
  },
  methods: {
    change (val) {},
    deleteRow (index) {
      this.selectHospitalList_info.splice(index, 1)
    },
    selectHospital () {
      this.is_hospital = true
    },
    closeHospitalDialog () {
      this.is_hospital = false
    },
    selectHospitalList (val) {
      this.selectHospitalList_info = val
      let newArr = []
      this.selectHospitalList_info.forEach(item => {
        newArr.push(item.id)
        this.formValue.hospitalIds = newArr
      })
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
  .menu-permissions {
    // margin-bottom: 20px;
    line-height: 40px;
  }

  .pt-doctor-form {
    table {
      padding: 0 20px;
    }

    :global .wt-input input {
      width: 3rem !important;
    }
  }

  // .role-customer-basic-message {
  //   max-width: 500px
  // }
  .role-customer-basic-message{
    width: 100%;
    display: table!important;

    th,tr{
        display: table-row;
        width: 100%;
    }
     :global
    .wt-input{
        overflow: initial;
    }
    .el-input{
        width: auto!important
    }
    td{
        // padding-bottom: 10px;
        font-size: 14px;
        // color: @tipTextColor
    }
    textarea{
        max-width: 280px;
        font-family: "Microsoft YaHei", "\5FAE\8F6F\96C5\9ED1", "Avenir", Helvetica, Arial!important
    }
}
  .org-select {
    min-width: 450px;
  }

  .edit-password-text {
    color: red;
    font-size: 12px
  }

  .specification-table-div {
    margin: 20px 0;
    padding: 30px 50px;
  }

  .specification-table{
    display: table!important;
    width: 100%;
    border-collapse:collapse!important;
    th,tr{
        width: 100%!important;
        max-width: 100%!important;
        display: table-row;
        padding: 0!important;
        list-style-type:none;
        border-bottom: 1px solid #C6C9D3;
        color: #818181
    }
    td{
        text-align: center;
        padding: 10px;
    }
}
</style>
